export const projects = [
  {
    url: "how-to-work",
    title: "How to Work",
    markdownFileName: "how-to-work.md",
    imageFileName: "how-to-work.png",
    date: "2023-02-27T10:50:00+03:00",

    seo: {
      description: "How to Work",
      keywords: "how, to, work",
    },
  },
];
